import React, { Component } from 'react';
import JobsOperationsApiHandler from './../../JobsOperationsApiHandler.js';
import Loader from './../../../../commons/Loader.js';
import Checkbox from '@material-ui/core/Checkbox';
import Popover from '@material-ui/core/Popover';
import CircularProgress from '@material-ui/core/CircularProgress';
import TripTypeGeneration from './TripTypeGeneration.js';
import ErrorBox from './../../../../commons/ErrorBox';
import NewDropSelector from './../../../../commons/NewDropSelector.js';


var selectedFacility = JSON.parse(localStorage.getItem('selectedFacility'));

const datefor = new Intl.DateTimeFormat('en-GB', {
	year: 'numeric',
	month: 'short',
	day: '2-digit'
});

let genNames = { 
	CRATE_SORTING: 'Inventory Products',
	BULK_SORTING: 'Inventory Products',
	IN_TRANSIT_INVENTORY_SORTING: 'Seller Products ',
	HUB_LEVEL_BULK_SORTING: 'Inventory Products',
	TRIP_LEVEL_BULK_SORTING:'Inventory Products',
	IN_TRANSIT_INVENTORY_SORTING_HUB_LEVEL: 'Seller Products ',
	IN_TRANSIT_INVENTORY_SORTING_TRIP_LEVEL: 'Seller Products ',
	COLD_STORAGE_HUB_LEVEL_SORTING: 'Cold Storage',
	COLD_STORAGE_TRIP_LEVEL_SORTING: 'Cold Storage' };

export default class SortingGeneration extends Component {
	constructor(props) {
		super(props);
		this.state = {
			anchorEl: null,
			open: false,
			allUsers: null,
			users: [],
			selectedUser: [],
			selectedTrips: [],
			selectedType: null,
			loading: false,
			generationData: null,
			showPageLoader: false,
			error: null,
			selectedGenerationType: null,
			generationTypes: [],
			showAllUsers: false,
			loadFetchUsers: false
		}
	};

	//<!------------------------------ Setting Data in state (from props and after recall of API after asignment) ------------------------------!>
	setDataToState = (generationData) => {
		this.setState({
			generationData: generationData
		})
		this.fetchUser(false);
	}

	setGenerationTypes = () => {
		const { processType } = this.props;
		let generationTypes = [];
		let selected = null;
		if (processType.processPhases && processType.processPhases.length > 1) {
			processType.processPhases.forEach(i => {
				generationTypes.push({ val: [i], name: genNames[i] });
			})
		}
		generationTypes.push({ val: processType.processPhases, name: 'All Pending' });
		if (processType.processPhases.length === 1) {
			selected = generationTypes[0];
		}
		this.setState({ generationTypes: generationTypes, selectedGenerationType: selected });
	}

	componentWillMount() {
		this.setDataToState(this.props.generationData);
		this.setGenerationTypes();
	}


	closeError = () => { this.setState({ error: null }) }

	//<!------------------------------ Fetching All fc heroes for SORTING ------------------------------!>
	fetchUser(showAllUsers) {
		//showAllUsers === true : get all users ? get users for that facility

		this.setState({ loadFetchUsers: true });
		JobsOperationsApiHandler.getFcUsersForProcessType('SORTING', showAllUsers)
			.then(function (resp) {
				this.setState({ allUsers: resp, users: resp });
			}.bind(this)).catch(function (error) {
				this.setState({ error: error.error.error });
			}.bind(this)).finally(function () {
				this.setState({ loadFetchUsers: false });
			}.bind(this));
	};


	//<!------------------------------ Fetching Data Again ------------------------------!>
	refreshPage = () => {
		let req = {
			dispatchSlotId: this.state.generationData.dispatchSlotId,
			hubId: this.state.generationData.hubId,
			processPhases: this.props.processType.processPhases
		};

		this.setState({ showPageLoader: true, selectedUser: [], selectedTrips: [], selectedGenerationType: null });

		JobsOperationsApiHandler.getTripsForHubAndSlot(req)
			.then(function (resp) {
				this.setDataToState(resp);
			}.bind(this)).catch(function (error) {
				this.setState({ error: error.error.error });
			}.bind(this)).finally(function () {
				this.setState({ showPageLoader: false })
			}.bind(this));
	}

	//<!------------------------------ Assigning Jobs or (Jobs Generation) ------------------------------!>
	assignJobs = () => {
		if (this.state.selectedUser.length > this.state.selectedTrips.length) {
			return;
		} else if (!this.state.loading) {

			this.setState({ loading: true });

			let trips = this.state.selectedTrips.map((t) => {
				let phases = [];
				let v = this.state.selectedGenerationType.val;
				if (v.length > 1) {
					t.processPhaseLevelDetailsList.forEach(l => {
						if (v.includes(l.processPhase) && (l.processStatus !== 'JOBS_GENERATED' && l.processStatus !== 'NOT_REQUIRED')) {
							phases.push(l.processPhase);
						}
					})
				} else {
					phases.push(v[0]);
				}
				return { tripId: t.tripId, processPhases: phases }
			});

			var req = {
				// tripIds: this.state.selectedTrips,
				// processPhases: this.state.selectedGenerationType.val,
				tripDetails: trips,
				userIds: this.state.selectedUser,
				facilityId: selectedFacility.facilityId,
				dispatchSlotId: this.state.generationData.dispatchSlotId,
				tripType: this.state.selectedType
			};

			JobsOperationsApiHandler.generateDispatchSortingJobs(req)
				.then(function (resp) {
					this.handleClose();
					this.refreshPage();
				}.bind(this)).catch(function (error) {
					this.setState({ error: error.error.error });
				}.bind(this)).finally(function () {
					this.setState({ loading: false });
				}.bind(this));
		}
	}


	//<!------------------------------ Handling FC heroes selection ------------------------------!>
	handleCheck(user) {
		var selectedUsers = this.state.selectedUser;
		var found;
		for (var i in selectedUsers) {
			if (user.naturalId === selectedUsers[i]) {
				found = i;
			}
		}

		if (found) {
			user.checkedVal = false;
			selectedUsers.splice(found, 1);
		} else {
			user.checkedVal = true;
			selectedUsers.push(user.naturalId);
		}

		this.setState({ selectedUser: selectedUsers });
	};


	//<!------------------------------ Handling Assign User Dialoge ------------------------------!>
	handleClick = placement => event => {
		const { currentTarget } = event;
		this.setState(state => ({
			open: state.placement !== placement || !state.open,
			anchorEl: currentTarget,
			users: this.state.allUsers
		}));
	};


	//<!------------------------------ Handling Close Dialoge ------------------------------!>
	handleClose = () => {
		this.setState({ open: false });
	};


	//<!------------------------------ Filter the List ------------------------------!>
	filterList(event) {
		var updatedList = this.state.allUsers;
		updatedList = updatedList.filter(function (item) {
			return item.displayName.toLowerCase().search(event.target.value.toLowerCase()) !== -1;
		});
		this.setState({ users: updatedList });
	}


	//<!-------------------- Hiding Generation Screen --------------------!>
	hideGenerations() {
		this.props.hideGenerations();
	}

	//<!-------------------- when 'Show All users' checkbox is clicked --------------------!>
	changeUsers = (showAllUsers) => {
		this.setState({ showAllUsers: !showAllUsers });
		this.fetchUser(!showAllUsers);
	}

	//<!------------------------------ Rendering Assign Heroes ------------------------------!>
	assignUser() {
		const { showAllUsers, loadFetchUsers } = this.state;
		if (this.state.allUsers) {

			var heroes = this.state.users.map((hero, index) => {

				if (hero.checkedVal === undefined) {
					hero.checkedVal = false;
				}
				return (
					<div className="hero" key={index}>
						<div className="row">
							<div className="col-md-1 col-sm-1 col-xs-2">
								<Checkbox checked={hero.checkedVal} onChange={() => { this.handleCheck(hero) }} value={hero.naturalId} classes={{ root: 'cstmCheckBox', checked: 'greenChecked' }} />
							</div>
							<div className="col-md-11 col-sm-11 col-xs-10">
								<div>{hero.displayName} ({hero.phoneNumber})</div>
							</div>
						</div>
					</div>
				)
			});


			return (
				<div style={{ width: '400px' }}>
					<div style={{ padding: '19px' }}>
						<div className="assign-title">Assign Sorting Jobs</div>
						<div style={{ fontSize: '13px', color: 'gray', marginTop: '5px' }}>
							<Checkbox checked={showAllUsers} onChange={(e) => { this.changeUsers(showAllUsers) }} classes={{ root: 'cstmCheckBox', checked: 'greenChecked' }} /> <span style={{ marginRight: '5px' }}>Show All Users</span>
							{loadFetchUsers ? <CircularProgress style={{ color: '#000' }} size={15} thickness={3} /> : null}
						</div>
						<div className="seperator"></div>
						<div className="assing-fc-rule">* 1 Trip = 1 FC Hero</div>
						<div className="filter-fc-hero">
							<input type="text" className="fc-search-box" onChange={this.filterList.bind(this)} placeholder="Search by FC Hero" /> <i className="fas fa-search" style={{ color: '#797979' }}></i>
						</div>
						<div className="fc-heroes top-ten">
							{heroes}
						</div>
					</div>
					<div className="assign-job-box">
						<div className="row">
							<div className="col-md-8">
								{(this.state.loading) ?
									<div className="pull-right">
										<CircularProgress style={{ color: '#000', lineHeight: '18px' }} size={23} thickness={3} />
									</div> : null
								}
								{(this.state.selectedUser.length > this.state.selectedTrips.length) ?
									<div className="errorText" style={{ lineHeight: '34px' }}>FC Heroes can not be more then trips</div> : null
								}
							</div>
							<div className="col-md-4">
								<div className="pull-right">
									<button className={"btn btn-default " + ((this.state.selectedUser.length <= this.state.selectedTrips.length) && this.state.selectedUser.length > 0 && !this.state.loading ? "btn-jt-green" : "back-button")} onClick={this.assignJobs} disabled={(this.state.selectedUser.length > this.state.selectedTrips.length) || this.state.selectedUser.length === 0 || this.state.loading ? true : false}>Assign Jobs</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			);
		}
	}


	tripSelectionPerform = (data) => {
		var selectedType = this.state.selectedType;
		if (data.selectedTrips.length === 0) {
			selectedType = null;
		} else {
			selectedType = data.selectedType;
		}

		//Performing Disabling the generation type options.
		let p = this.props.processType.processPhases;
		let generationTypes = this.state.generationTypes;
		if (p.length > 1) {
			let optns = {};

			p.forEach(i => {
				optns[i] = false;
			});

			data.selectedTrips.forEach(trip => {
				trip.processPhaseLevelDetailsList.forEach(itm => {
					if (itm.processStatus === 'JOBS_GENERATED') {
						optns[itm.processPhase] = true;
					}
				})
			});

			generationTypes = generationTypes.map(i => {
				if (i.val.length === 1) {
					i['disabled'] = optns[i.val[0]];
				}
				return i;
			});

		}

		this.setState({ selectedTrips: data.selectedTrips, selectedType: selectedType, generationTypes: generationTypes })
	}

	getTripTypeWiseData() {
		var types;
		if (this.state.generationData.tripTypeWisePickingDetails) {
			types = this.state.generationData.tripTypeWisePickingDetails.map((type, index) => {
				return <TripTypeGeneration type={type} tripSelectionPerform={this.tripSelectionPerform} selectionFrom={this.state.selectedType} onRefresh={this.refreshPage} key={index} />
			})
		}
		return types;
	}


	generationTypeSelected = (type) => {
		this.setState({ selectedGenerationType: type });
	}

	render() {
		const { open, anchorEl } = this.state;

		//<!-------------------- Fetching all users to assign trips --------------------!>
		// if (!this.state.allUsers) {
		// 	this.fetchUser(false);
		// }

		var generateData = this.state.generationData;
		return (
			<div>
				<div className="putaway-header">
					<div className="row">
						<div className="col-md-1 col-sm-3 col-xs-3">
							<button className="btn btn-default back-button" onClick={this.hideGenerations.bind(this)}><i className="fas fa-chevron-left"></i> &nbsp;&nbsp;Back</button>
						</div>
						<div className="col-md-5 no-xs-padding-left-thirty">
							<div className="slot-name-date">
								{generateData.hubName} - {datefor.format(generateData.deliveryDate)} - {generateData.dispatchSlotName} - {this.props.processType.sortingTypeDescription}
							</div>
						</div>
						<div className="col-md-2">
							<div style={{ lineHeight: '35px', textAlign: 'right' }}><span style={{ opacity: '0.8' }}>Trips Selected: </span>{this.state.selectedTrips.length}</div>
						</div>
						<div className="col-md-2 col-sm-3 col-xs-6 no-left-padding">
							<NewDropSelector options={this.state.generationTypes} selected={this.state.selectedGenerationType} classes={'pull-right'} selctionChange={this.generationTypeSelected} type={'Generation Type'} value={'name'} disabled={this.state.selectedTrips.length === 0} />
						</div>
						<div className="col-md-2 col-sm-3 col-xs-6">
							<button className={"btn choose-button pull-right " + ((this.state.selectedTrips.length > 0 && this.state.selectedGenerationType) ? "btn-jt-green" : "btn-default")} onClick={this.handleClick('bottom-end')} disabled={(this.state.selectedTrips.length < 1 || !this.state.selectedGenerationType) ? "disabled" : null}>Choose FC Hero</button>
							<Popover open={open} anchorEl={anchorEl} onClose={this.handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
								{this.assignUser()}
							</Popover>
						</div>
					</div>
				</div>

				{(this.state.showPageLoader) ?
					<Loader />
					:
					<div style={{ padding: '20px 30px' }}>
						{this.getTripTypeWiseData()}
					</div>

				}
				{(this.state.error) ?
					<ErrorBox errorText={this.state.error} closeError={this.closeError} /> : null
				}
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/screens/JobOperations/Components/Commons/SortingGeneration.js